// A route chunk that no longer exists on the server: every deploy replaces the
// hashed /assets/*.js files, so any client (a tab left open, Google's renderer
// with a cached HTML) still holding the previous HTML gets a 404 on its next
// dynamic import. Message shapes: Chrome, Firefox, Safari.
const CHUNK_LOAD_RE =
  /dynamically imported module|Importing a module script failed/i

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_LOAD_RE.test(error.message)
}
